import { FilesPageView } from '@/features/my-files/files-page';
import { useStudentDocumentDestinations } from '@/lib/documents/destinations';

/** « Mes fichiers » côté élève : ses tuteurs (jamais de classe — dépôt réservé au tuteur). */
export function StudentFilesPage() {
  const { destinations, isLoading } = useStudentDocumentDestinations();
  return <FilesPageView destinations={destinations} destinationsLoading={isLoading} />;
}
